/**
 * StatusBadge — Shared component thay thế tất cả getStatusBadge duplicated functions
 *
 * Usage:
 *   <StatusBadge type="QuotationStatus" value={quotation.status} />
 *   <StatusBadge type="OrderStatus" value="COMPLETED" />
 *   <StatusBadge type="MachineStatus" value={machine.status} size="sm" />
 */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getStatusConfig, type StatusRegistryKey } from '@/config/status-registry';

interface StatusBadgeProps {
    /** Tên enum trong STATUS_REGISTRY */
    type: StatusRegistryKey;
    /** Giá trị status (e.g. 'DRAFT', 'APPROVED') */
    value: string;
    /** Size variant */
    size?: 'xs' | 'sm' | 'default';
    /** Additional className */
    className?: string;
    /** Show dot indicator */
    showDot?: boolean;
}

export function StatusBadge({ type, value, size = 'default', className, showDot }: StatusBadgeProps) {
    const config = getStatusConfig(type, value || 'UNKNOWN');

    const sizeClasses = {
        xs: 'text-[9px] px-1.5 py-0 h-4',
        sm: 'text-[10px] px-2 py-0 h-5',
        default: 'text-[10px] px-2 py-0.5',
    };

    return (
        <Badge
            variant="outline"
            className={cn(
                'font-bold uppercase border-none whitespace-nowrap',
                sizeClasses[size],
                config.color,
                className,
            )}
        >
            {showDot && config.dotColor && (
                <span className={cn('inline-block h-1.5 w-1.5 rounded-full mr-1.5', config.dotColor)} />
            )}
            {config.label}
        </Badge>
    );
}
